













import Checkbox from './checkbox.component.vue';

export default {
  name: 'epb-checkbox-group',
  components: {
    Checkbox
  },
  props: {
    value: Array,
    options: {
      type: Array,
      required: true
    },
    multiSelect: {
      type: Boolean,
      default: true
    },
    emptyAllowed: Boolean,
    alwaysFilled: Boolean,
    vertical: Boolean
  },
  methods: {
    isOptionSelected: function (optionId: string): boolean {
      return !!this.value && this.value.includes(optionId);
    },
    onCheckboxChange: function (optionId: string, checked: boolean): void {
      let selectedOptions = this.value;
      if (checked) {
        if (this.multiSelect) {
          selectedOptions.push(optionId);
        } else {
          selectedOptions = [optionId];
        }
      } else if (selectedOptions.length > 1 || this.emptyAllowed) {
        selectedOptions.splice(selectedOptions.indexOf(optionId), 1);
      }
      this.$emit('input', selectedOptions);
    }
  }
};
